import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { ModeProvider } from "@/lib/mode";
import DecisionRoom from "@/pages/DecisionRoom";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ModeProvider>
          <Routes>
            <Route path="/" element={<DecisionRoom />} />
            <Route path="/decision-room" element={<DecisionRoom />} />
            <Route path="/mba/pisa-decision-room" element={<DecisionRoom />} />
            <Route path="/member/pisa-decision-room" element={<DecisionRoom />} />
            <Route path="*" element={<Navigate to="/decision-room" replace />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </ModeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
